import { BulkResponse } from "../../../../../data";
import { OrderDto, orderService } from "../../../../../domain";

export const onReviewAll = (orderId: number[]): Promise<BulkResponse[]| undefined> => {
    return orderService
        .reviewAll(orderId)
        .then(res => {
            return res;
        })
        .catch(() => {
            return undefined;
        });
}